import React, { Component, useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { createValue, Fieldset, validate } from '@bigfishtv/react-forms'
import { validationErrors } from 'react-forms-cakephp'

import invalidateExternalErrorList from '../utils/invalidateExternalErrorList'

import FormButton from '../components/FormButton'
import Field from '../components/Field'

function validateEmail(email) {
  const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regexp.test(email)
}

const FormFields = ({ formValue, preferences, skipPreferences, onSubmitReady, list }) => {
  const [hideName, setHideName] = useState(false)
  const [hideEmail, setHideEmail] = useState(true)
  const [hidePreferences, setHidePreferences] = useState(true)
  const emailFieldRef = useRef(null)

  const hideNameShowEmail = () => {
    if (!formValue.value.first_name.length || !formValue.value.last_name.length) {
      return
    }
    setHideEmail(false)
    setHideName(true)
  }

  const hideEmailShowLocation = () => {
    if (!formValue.value.email.length || !validateEmail(formValue.value.email) || !formValue.value.postcode.length) {
      return
    }
    setHideEmail(true)
    setHidePreferences(false)
  }

  useEffect(() => {
    if (!hideEmail) emailFieldRef.current?.focus?.()
  }, [hideEmail])

  useEffect(() => {
    if (skipPreferences) {
      if (hideEmail === false) onSubmitReady(true)
      else onSubmitReady(false)
    } else {
      if (hidePreferences === false) onSubmitReady(true)
      else onSubmitReady(false)
    }
  }, [hidePreferences, skipPreferences, hideEmail])

  return (
    <div className="footer-subscribe">
      {!hideName && (
        <div className="fields border">
          <Field className="flex-auto" select="first_name" placeholder="First Name" label="" required />
          <Field className="flex-auto" select="last_name" placeholder="Last Name" label="" required />
          <button
            className="button button-white button-s margin-vertical-auto margin-horizontal-xxs-s-up"
            onClick={() => hideNameShowEmail()}>
            Next
          </button>
        </div>
      )}
      {!hideEmail && (
        <div className="fields">
          <Field
            ref={elem => (emailFieldRef.current = elem)}
            className="flex-auto"
            select="email"
            type="email"
            placeholder="Email"
            label=""
            required
          />
          <Field
            className="flex-auto max-width-xxs-s-up"
            placeholder="Postcode"
            select="postcode"
            type="tel"
            label=""
            required
          />
          {!skipPreferences && (
            <button
              className="button button-white button-s margin-vertical-auto margin-horizontal-xxs-s-up"
              onClick={() => hideEmailShowLocation()}>
              Next
            </button>
          )}
        </div>
      )}
      {!hidePreferences && (
        <div className="margin-vertical-s">
          <Field
            select="preferences"
            label=""
            inline
            type="checkboxes"
            text="Subscription Preferences"
            options={preferences}
            required
          />
        </div>
      )}
    </div>
  )
}

const SuccessMessage = () => (
  <div>
    <p className="font-size-l font-weight-regular">Thank you for subscribing.</p>
  </div>
)

class FooterSubscribeForm extends Component {
  constructor(props) {
    super()
    this.state = {
      formValue: createValue({
        value: props.defaultValue || { preferences: props.preferences.map(({ value }) => value) },
        onChange: this.onChange,
      }),
      submitStatus: 'ready',
      submitReady: false,
    }
  }
  onChange = formValue => {
    formValue = invalidateExternalErrorList(formValue, this.state.formValue)
    this.setState({ formValue, submitStatus: this.state.submitStatus != 'busy' ? 'ready' : 'busy' })
  }
  handleSubmit = event => {
    event.preventDefault()

    if (this.state.submitStatus == 'busy') return

    this.setState(
      {
        submitStatus: 'busy',
      },
      () => {
        window.jQuery.ajax({
          type: 'POST',
          url: '/api/subscribers/submit.json',
          data: JSON.stringify(this.state.formValue.value),
          contentType: 'application/json',
          dataType: 'json',
          success: () => {
            this.setState({ submitStatus: 'success' })
          },
          error: response => {
            if (response.responseJSON && response.responseJSON.errors) {
              this.onChange(
                createValue({
                  value: this.state.formValue.value,
                  onChange: this.onChange,
                  params: { forceShowErrors: true },
                  externalErrorList: validationErrors(response.responseJSON.errors),
                })
              )
            }
            this.setState({ submitStatus: 'failed' })
          },
        })
      }
    )
  }
  render() {
    const { submitStatus } = this.state
    if (submitStatus === 'success') {
      return (
        <div>
          <SuccessMessage />
        </div>
      )
    }

    return (
      <Fieldset stylesheet={{ Root: 'form' }} formValue={this.state.formValue} onSubmit={this.handleSubmit}>
        <FormFields
          list={this.props.list}
          formValue={this.state.formValue}
          preferences={this.props.preferences}
          onSubmitReady={val => this.setState({ submitReady: val })}
          skipPreferences={this.props.skipPreferences}
        />
        {this.state.submitReady && (
          <FormButton onSubmit={this.handleSubmit} submitStatus={submitStatus} submitClassName="button-white" />
        )}
      </Fieldset>
    )
  }
}

window.FooterSubscribeForm = {
  init: (id, props) => {
    if (!props.preferences) {
      // Tag grabbed from insomnia
      props.preferences = [{ value: '243', text: 'At The Barre – Queensland Ballet eNews' }]
    }
    ReactDOM.render(<FooterSubscribeForm {...props} formId={id} />, document.getElementById(id))
  },
}
